var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarIconLb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    "data-name": "Component 182 \\u2013 4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3b5175",
    stroke: "#707070",
    d: "M286 11h18v18h-18z",
    "data-name": "Rectangle 14933"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    "data-name": "Mask Group 1053",
    transform: "translate(-286 -11)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M286 11h18v18h-18z",
    "data-name": "Rectangle 14929"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#3b5175",
    "data-name": "icons Q2",
    transform: "translate(286 11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 3h-3.375V1.537a.787.787 0 0 0-.638-.787.75.75 0 0 0-.862.75V3h-5.25V1.537A.788.788 0 0 0 5.737.75a.75.75 0 0 0-.862.75V3H1.5a.75.75 0 0 0-.75.75v12a.75.75 0 0 0 .75.75h15a.75.75 0 0 0 .75-.75v-12A.75.75 0 0 0 16.5 3Zm-.75 12H2.25V7.5h13.5Zm0-9H2.25V4.5h13.5Z",
    "data-name": "Path 20424"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 3,
    "data-name": "Rectangle 14930",
    rx: 0.75,
    transform: "translate(3 9)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 3,
    "data-name": "Rectangle 14931",
    rx: 0.75,
    transform: "translate(12 9)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 3,
    "data-name": "Rectangle 14932",
    rx: 0.75,
    transform: "translate(7.5 9)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIconLb);
export default __webpack_public_path__ + "static/media/calendarIconLB.86c8e8d0dbe02779091cf298bd4dbf1a.svg";
export { ForwardRef as ReactComponent };